<template>
  <vs-popup
    title="Yüklenen Excel'ler"
    :active.sync="isActiveLocal"
    class="job-listesi-popup"
    style="z-index: 52000"
  >
    <div id="loading-job-listesi" class="vs-con-loading__container">
      <b-row align-v="end" class="mb-1">
        <b-col cols="6" md="3" class="mb-1">
          <label>Durum</label>
          <b-form-select
            class="w-100 durum-select"
            v-model="jobFiltre.jobDurum"
            :options="jobDurumSecenekleri"
          />
        </b-col>
        <b-col cols="6" md="3" class="mb-1">
          <label>Oluşturma Tarihi</label>
          <vs-input
            type="date"
            class="w-100"
            v-model="jobFiltre.olusturmaTarihi"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-1 filtre-butonlar d-flex align-items-end justify-content-end"
        >
          <vs-button
            style="border-radius: 5px"
            color="primary"
            type="border"
            class="mr-1"
            @click="jobFiltreTemizle()"
          >
            Temizle
          </vs-button>
          <vs-button
            style="border-radius: 5px"
            color="primary"
            @click="jobListesiniGetir(1)"
          >
            Filtrele
          </vs-button>
        </b-col>
      </b-row>

      <ag-grid-vue
        style="width: 100%; margin-top: 5px"
        class="ag-theme-alpine job-listesi-grid"
        :enableCellChangeFlash="true"
        :animateRows="true"
        :defaultColDef="jobDefaultColDef"
        :columnDefs="jobColumnDefs"
        :rowData="jobRowData"
        :localeText="localeText"
        :suppressCopyRowsToClipboard="true"
        :masterDetail="true"
        :detailCellRendererParams="detailCellRendererParams"
        :detailRowAutoHeight="true"
        :rowClassRules="jobRowClassRules"
      >
      </ag-grid-vue>

      <b-row align-v="center" class="mt-2">
        <b-col cols="6">
          <vs-button
            size="small"
            color="primary"
            type="border"
            style="border-radius: 5px"
            :disabled="jobFiltre.sayfa <= 1"
            @click="jobListesiniGetir(jobFiltre.sayfa - 1)"
          >
            Önceki
          </vs-button>
          <span class="mx-2">
            Sayfa {{ jobMeta.sayfa }} / {{ jobMeta.toplamSayfa || 1 }}
          </span>
          <vs-button
            size="small"
            color="primary"
            type="border"
            style="border-radius: 5px"
            :disabled="jobFiltre.sayfa >= (jobMeta.toplamSayfa || 1)"
            @click="jobListesiniGetir(jobFiltre.sayfa + 1)"
          >
            Sonraki
          </vs-button>
        </b-col>
        <b-col cols="6" style="text-align: end">
          Toplam {{ jobMeta.toplamKayit }} kayıt
        </b-col>
      </b-row>
    </div>
  </vs-popup>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";

export default {
  components: {
    AgGridVue,
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localeText: null,
      jobDurumSecenekleri: [
        { value: "", text: "Tümü" },
        { value: "TAMAMLANDI", text: "TAMAMLANDI" },
        { value: "ISLENIYOR", text: "İŞLENİYOR" },
        { value: "HATALI", text: "HATALI" },
        { value: "HAZIR", text: "HAZIR" },
        { value: "BEKLIYOR", text: "BEKLİYOR" },
      ],
      jobDefaultColDef: {
        sortable: true,
        resizable: true,
        filter: true,
      },
      jobColumnDefs: [
        { field: "dosyaAdi", headerName: "Dosya Adı", cellRenderer: "agGroupCellRenderer", minWidth: 200,},
        { field: "durum", headerName: "Durum", width: 140 },
        { field: "basariliSatir", headerName: "Başarılı", width: 100 },
        { field: "hataliSatir", headerName: "Hatalı", width: 100 },
        { field: "olusturmaTarihi", headerName: "Oluşturma", width: 170 },
        { field: "bitisTarihi", headerName: "Bitiş", width: 170 },
        { field: "mesaj", headerName: "Mesaj", minWidth: 220, flex: 1, wrapText: true, autoHeight: true},
      ],
      jobRowClassRules: {
        "satir-hatali": (params) =>
          params.data && Number(params.data.hataliSatir) > 0,
        "satir-basarili": (params) =>
          params.data &&
          Number(params.data.hataliSatir) === 0 &&
          Number(params.data.basariliSatir) > 0,
      },
      detailCellRendererParams: {
        // Job satırı açıldığında o job'a ait satırlar (satirlar) gösterilir.
        detailGridOptions: {
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: true,
          },
          rowClassRules: {
            "satir-hatali": (params) =>
              params.data &&
              String(params.data.durum).toUpperCase().indexOf("HATA") !== -1,
            "satir-basarili": (params) =>
              params.data &&
              params.data.durum &&
              String(params.data.durum).toUpperCase().indexOf("HATA") === -1,
          },
          columnDefs: [
            { field: "satirNo", headerName: "Satır No", width: 100 },
            { field: "pazaryeri", headerName: "Pazaryeri", width: 130 },
            { field: "stokKodu", headerName: "Stok Kodu", width: 130 },
            { field: "barkod", headerName: "Barkod", width: 150 },
            { field: "satisFiyati", headerName: "Satış Fiyatı", width: 120 },
            { field: "listeFiyati", headerName: "Liste Fiyatı", width: 120 },
            { field: "durum", headerName: "Durum", width: 120 },
            { field: "hataMesaji", headerName: "Hata Mesajı", minWidth: 260, flex: 1, wrapText: true, autoHeight: true, cellStyle: { color: "#e24733" }},
          ],
        },
        getDetailRowData: (params) => {
          params.successCallback(params.data.satirlar || []);
        },
      },
      jobRowData: [],
      jobMeta: {
        sayfa: 1,
        sayfaBoyutu: 20,
        toplamKayit: 0,
        toplamSayfa: 1,
      },
      jobFiltre: {
        jobGuid: "",
        jobDurum: "",
        olusturmaTarihi: "",
        sayfa: 1,
        sayfaBoyutu: 20,
      },
    };
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },
  watch: {
    isActive(val) {
      if (val) {
        this.jobFiltre.sayfa = 1;
        this.jobListesiniGetir(1);
      }
    },
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  methods: {
    bildir(text, color, title) {
      this.$vs.notify({
        title,
        text,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color,
        position: "top-center",
      });
    },
    soapIstek(metod, args) {
      return new Promise((resolve, reject) => {
        const soap = require("soap");
        soap.createClient(state.sistemAddress, (err, client) => {
          if (err) return reject(err);
          client[metod](args, (err, result) => {
            if (err) return reject(err);
            const ham = result && result[metod + "Result"];
            if (ham == "-1") {
              Store.dispatch("logout");
              return reject(new Error("logout"));
            }
            try {
              resolve(JSON.parse(ham));
            } catch (parseError) {
              reject(parseError);
            }
          });
        });
      });
    },
    jobFiltreTemizle() {
      this.jobFiltre.jobGuid = "";
      this.jobFiltre.jobDurum = "";
      this.jobFiltre.olusturmaTarihi = "";
      this.jobListesiniGetir(1);
    },
    async jobListesiniGetir(sayfa) {
      const vs = this.$vs;
      this.jobFiltre.sayfa = sayfa < 1 ? 1 : sayfa;
      vs.loading({ container: "#loading-job-listesi", type: "radius" });

      try {
        const parsed = await this.soapIstek("topluFiyatJobListesi", {
          token: Store.state.tokenId,
          jobGuid: this.jobFiltre.jobGuid,
          jobDurum: this.jobFiltre.jobDurum,
          olusturmaTarihi: this.jobFiltre.olusturmaTarihi,
          sayfa: this.jobFiltre.sayfa,
          sayfaBoyutu: this.jobFiltre.sayfaBoyutu,
        });

        if (!(parsed.response == "Ok" && parsed.error == "No")) {
          this.bildir(
            parsed.mesaj || parsed.message || "Kayıtlar getirilemedi.",
            "danger",
            "Yüklenen Excel'ler"
          );
        }

        this.jobRowData = parsed.jobs || [];
        this.jobMeta = {
          sayfa: parsed.sayfa || this.jobFiltre.sayfa,
          sayfaBoyutu: parsed.sayfaBoyutu || this.jobFiltre.sayfaBoyutu,
          toplamKayit: parsed.toplamKayit || 0,
          toplamSayfa: parsed.toplamSayfa || 1,
        };
      } catch (error) {
        console.log(error);
        if (error.message !== "logout") {
          this.bildir("Kayıtlar getirilemedi.", "danger", "Yüklenen Excel'ler");
        }
      } finally {
        vs.loading.close("#loading-job-listesi > .con-vs-loading");
      }
    },
  },
};
</script>

<style>
.job-listesi-popup .vs-popup {
  width: 90%;
  height: 90%;
  max-width: 1400px;
}
.job-listesi-popup .vs-popup--content {
  height: calc(100% - 54px);
}
.job-listesi-popup .vs-con-loading__container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.job-listesi-popup .job-listesi-grid {
  flex: 1 1 auto;
  min-height: 0;
}
.job-listesi-popup .durum-select {
  height: 40px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0 0.75rem;
  color: #626262;
  background-color: #fff;
}
.job-listesi-popup .durum-select:focus {
  border-color: rgba(115, 103, 240, 0.6);
  box-shadow: none;
}
.job-listesi-popup .filtre-butonlar {
  flex-wrap: nowrap;
  white-space: nowrap;
}
.job-listesi-popup .filtre-butonlar .vs-button {
  flex: 0 0 auto;
}
.ag-theme-alpine .ag-row.satir-basarili,
.ag-theme-alpine .ag-row.satir-basarili.ag-row-hover {
  background-color: rgba(40, 199, 111, 0.15);
}
.ag-theme-alpine .ag-row.satir-hatali,
.ag-theme-alpine .ag-row.satir-hatali.ag-row-hover {
  background-color: rgba(234, 84, 85, 0.15);
}
</style>
